import { FunctionComponent, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { translateError } from '@/utils/translateError';
import { useReduxDraftDispatch } from '@/redux/draft/draftDispatch';
import { getDraftErrorCount } from '@/redux/draft/getters/getDraftErrorCount';
import { getErrorForSelectedConfiguration } from '@/redux/draft/getters/getErrorForSelectedConfiguration';
import { getSelectedConfiguration } from '@/redux/draft/getters/getSelectedConfiguration';
import { setSelectedAnyConfigurationWithErrorAction } from '@/components/draft/draftState/actions/setSelectedAnyConfigurationWithErrorAction';
import './ConfigurationErrorBubble.scss';

export const ConfigurationErrorBubble: FunctionComponent = () => {
  const dispatch = useReduxDraftDispatch();
  const selectedConfiguration = useSelector(getSelectedConfiguration);
  const selectedConfigurationError = useSelector(getErrorForSelectedConfiguration);
  const errorCount = useSelector(getDraftErrorCount);
  const hasError = Boolean(selectedConfigurationError);

  const [isConfigurationErrorVisible, setIsConfigurationErrorVisible] = useState(hasError);

  useEffect(() => {
    if (isConfigurationErrorVisible) {
      const timer = setTimeout(() => setIsConfigurationErrorVisible(false), 5000);
      return () => clearTimeout(timer);
    }
    // reset the timer if the selected configuration changes
  }, [isConfigurationErrorVisible, selectedConfiguration?.cid]);

  useEffect(() => {
    setIsConfigurationErrorVisible(hasError);
  }, [hasError]);

  if (errorCount === 0) {
    return null;
  }

  return (
    <div className="configuration-error-bubble">
      <button
        type="button"
        className="configuration-error-bubble__count"
        onClick={() => {
          if (selectedConfiguration && hasError) {
            setIsConfigurationErrorVisible(true);
          } else {
            dispatch(setSelectedAnyConfigurationWithErrorAction);
          }
        }}
      >
        {errorCount}
      </button>
      {isConfigurationErrorVisible && selectedConfigurationError && (
        <button
          className="configuration-error-bubble__text"
          onClick={() => setIsConfigurationErrorVisible(false)}
        >
          {translateError(selectedConfigurationError)}
        </button>
      )}
    </div>
  );
};
